import React, { useState } from 'react'
import vectorarrow from "../../src/Images/vectorarrow.png"
import HttpClient from '../utils/HttpClient';
import toast from 'react-hot-toast';
import PostSummary from "../View/SearchHome/components/PostSummary";

const PostEnqueyModalNew = ({ closemodal, post, postData }) => {
    const [drowdowsncustom, setDrowdowsncustom] = useState(false)
    const drowdowncustclick = () => {
        setDrowdowsncustom(!drowdowsncustom)
    }

    const initialData = {
        postId: post,
        name: "",
        workEmail: "",
        mobile: "",
        typeOfEnquiry: "",
        enquirySubject: "",
        enquiry: "",
        file: ""
    }
    const [formData, setFormData] = useState(initialData);
    const __updateForm = (name, value) => {

        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    ////////////////Word Limit
    const maxWords = 60;

    const updateForm = (key, value) => {
        const words = value.trim().split(/\s+/).filter(Boolean);
        if (key === "enquiry") {
            if (words.length <= maxWords) {
                setFormData({ ...formData, [key]: value });
            }
        } else {
            setFormData({ ...formData, [key]: value });
        }
    }

    const wordCount = formData.enquiry.trim().split(/\s+/).filter(Boolean).length;
    const wordsRemaining = maxWords - wordCount;
    const [fileName, setFileName] = useState("");
    const [uploadedFilePath, setUploadedFilePath] = useState("")
    const [attachmentUploading, setAttachmentUploading] = useState(false)
    const [error, setError] = useState("");

    const imageUpload = async (file) => {
        if (!file) return;
        setError("");
        setAttachmentUploading(true);
        const formData = new FormData();
        formData.append("document", file);

        try {
            const res = await HttpClient.fileUploadWithoutAuth("image-document-upload", "POST", formData);
            if (res.status) {
                updateForm("file", res.data.url)
            } else {
                setError(res?.message || "Error while uploading file");
                console.log("Error while uploading file");
            }
        } catch (error) {
            setError("Error while uploading file");
            console.error("Upload failed:", error);
        } finally {
            setAttachmentUploading(false);
        }
    };

    const [uploadedFilePreview, setUploadedFilePreview] = useState("No file chosen")
    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                setError("Error: File size must be less than or equal to 5MB");
                return;
            }

            setFileName(file.name);
            setUploadedFilePreview(file.name)
            imageUpload(file);
        } else {
            setUploadedFilePreview("No file chosen")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            ...formData
        }
        if (!formData.name) {
            toast.error("Please enter first name");
        } else if (!formData.mobile) {
            toast.error("Please enter mobile number");
        } else if (!formData.workEmail) {
            toast.error("Please enter work email");
        } else if (!formData.typeOfEnquiry) {
            toast.error("Please enter type of enquiry");
        } else if (!formData.enquirySubject) {
            toast.error("Please enter subject");
        } else if (!formData.enquiry) {
            toast.error("Please enter message");
        } else {

            try {
                const response = await HttpClient.requestData("business-post-enquiry", "POST", data);
                if (response.status) {
                    toast.success(<>Enquiry sent successfully</>)
                } else {
                    console.error("Error in Post");
                }
            } catch (error) {
                console.error("Error submitting Post:", error);
            } finally {
                // dispatch(fetchMyBusinessPosts())
                closemodal()
            }
        }
    }

    const [ddlTypeOfEnquery, setDdlTypeOfEnquery] = useState(false)
    const ddlTypeOfEnqueryClick = () => {
        setDdlTypeOfEnquery(!ddlTypeOfEnquery)
    }

    const typeOfEnquery = [
        {
            name: "Buy/Sell",
            _id: "1"
        },
        {
            name: "Publish",
            _id: "2"
        }
    ]

    const handleopwmnpostmodal = (e, postData) => {

    }

    return (
        <div className='otherprofudvtmodalbackbox'>
            <div className='enquerysmokdnndbndbg'>
                <h5 className="mt-2 p-0 m-3">Send Enquery</h5>
                <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
                    <i className="fa-solid fa-xmark"></i>
                </div>
                <hr />

                <div className="psendwendijndwjjwndiv">
                    {/* <p className="breyuuayproosttxppp">Send Enquery</p> */}
                    <div className='compamydinfodivmainbtmhuhauhdsicflx'>
                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>First Name <span> * </span></p>
                            <input type="text" placeholder="john" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.name || ""}
                                onChange={(e) => updateForm("name", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Mobile number  <span> * </span></p>
                            <input type="number" placeholder="9173459034" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.mobile || ""}
                                onChange={(e) => updateForm("mobile", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Work email <span> * </span></p>
                            <input type="text" placeholder="info@companyname.com" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.workEmail || ""}
                                onChange={(e) => updateForm("workEmail", e.target.value)}
                            />
                        </div>

                        {/* <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Type of enquiry <span> * </span></p>
                            <div className='dropwdowndivfrmbusineenewwlas'>
                                <p className='vectoraarowdivomgulmaili'>
                                    Buy/Sell
                                </p>
                                <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                    <img src={vectorarrow} alt='...' />
                                </div>
                                {drowdowsncustom && <div className='vectoraarowdivomgulmai'>
                                    <ul className='vectoraarowdivomgulmaiul'>
                                        <li className='vectoraarowdivomgulmaili'>
                                            Buy/Sell
                                        </li>
                                    </ul>
                                </div>}
                            </div>
                        </div> */}

                        <div className='compamydinfodivmdiobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Type of enquiry <span> * </span></p>
                            <div className='dropwdowndivfrmbusineenewwlas' onClick={ddlTypeOfEnqueryClick}>
                                {
                                    formData.typeOfEnquiry ? (
                                        <p className='vectoraarowdivomgulmaili'>
                                            {formData.typeOfEnquiry}
                                        </p>
                                    ) : (
                                        <p className='vectoraarowdivomgulmaili'>
                                            --- Choose ---
                                        </p>
                                    )
                                }

                                <div className='vectoraarowdivomgnenwlal' onClick={ddlTypeOfEnqueryClick}>
                                    <img src={vectorarrow} alt='...' />
                                </div>
                                {ddlTypeOfEnquery && <div className='vectoraarowdivomgulmai'>
                                    <ul className='vectoraarowdivomgulmaiul'>
                                        {typeOfEnquery.map((type, index) => (
                                            <li
                                                key={index}
                                                className="vectoraarowdivomgulmaili"
                                                onClick={(e) => {
                                                    // handleInputChange("state", state);
                                                    // toggleDropdown("state");
                                                    updateForm("typeOfEnquiry", type?.name)
                                                    ddlTypeOfEnqueryClick()
                                                }}
                                            >
                                                {type?.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>}
                            </div>
                        </div>

                        <div className='_compamydinfodivmdiobbdgppshg compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Enquiry subject <span> * </span></p>
                            <input type="text" placeholder="Enter a subject" className="inpustxocntbusuitxtppnewallattyy"
                                value={formData.enquirySubject || ""}
                                onChange={(e) => updateForm("enquirySubject", e.target.value)}
                            />
                        </div>

                        <div className='compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Enquiry message <span> * </span></p>
                            {/* <textarea rows={4} cols={4} className='ennsjjuwtysttsxttaytredg'
                                value={formData.enquiry || ""}
                                onChange={(e) => updateForm("enquiry", e.target.value)}
                            /> */}

                            <textarea
                                rows={4}
                                cols={4}
                                className="ennsjjuwtysttsxttaytredg"
                                placeholder="Enter your message..."
                                value={formData.enquiry}
                                onChange={(e) => updateForm("enquiry", e.target.value)}
                            />
                            {/* <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                            {wordsRemaining} word{wordsRemaining !== 1 ? 's' : ''} remaining
                        </p> */}
                            <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                                ({wordsRemaining} - 60)
                            </p>



                        </div>



                        {/* <div className='compamydinfodivtesxtrareobbdgppshg'>
                            <p className='conattaindptxtppnewallasa'>Attachment <span>  </span></p>
                            <div className='chossefilkklkebdtrfdiv'>
                                <div className='enuqteyschosefllfbrdttdivdkdlnb'>


                                    <button className='enuqteyschosefllfbrdtt'>
                                        Choose file
                                    </button>
                                    <p>No file chosen</p>
                                </div>
                            </div>
                            <p className='alkoowjdiisdttxpp'>Allowed file types: JPG, PNG, PDF, Maximum allowed size is 2 MP</p>

                        </div> */}

                        <div className='poysttdiobnnnmmmnjm'>
                            <p className='conattaindptxtppnewallasa'>Attachment <span>  </span></p>
                            <div className='chossefilkklkebdtrfdiv'>
                                <div className='enuqteyschosefllfbrdttdivdkdlnb'>
                                    <input type="file" onChange={handleFileChange} />
                                    {attachmentUploading ? <><span>Uploading...</span></> : <>
                                        {uploadedFilePreview !== "No file chosen" && (
                                            formData?.file?.toLowerCase().endsWith('.pdf') ?
                                                <span><a href={formData?.file} target="_blank">View PDF</a></span> :
                                                <span> <img src={formData?.file} style={{ height: "72px" }} /></span>
                                        )}
                                    </>}
                                </div>
                            </div>
                            {error && <p className='alkoowjdiisdttxpp error'>{error}</p>}
                            <p className='alkoowjdiisdttxpp'>Allowed file types: JPG, PNG, PDF, Maximum allowed size is 5 MB</p>
                        </div>

                        <div className='poysttdiobnnnmmmnjm mt-2'>
                            <PostSummary data={postData} onOpen={(e) => handleopwmnpostmodal(e, postData)} />
                        </div>


                    </div>
                    <div className="svavtatvvbtnnmdivmaokin">
                        <button className="svavtatvvbtnnmsendferdgf"
                            onClick={(e) => handleSubmit(e)}
                        >Send enquiry</button>
                    </div>
                </div>



            </div>
        </div>
    )
}

export default PostEnqueyModalNew
